import { formatToTimeZone } from 'date-fns-timezone';

export const formatDate = (date) => {
  return formatToTimeZone(new Date(date), 'MMM DD', {
    timeZone: 'Etc/UTC'
  });
};

export const CLAIM_TYPES = {
  MEDICAL: 'MEDICAL',
  NON_MEDICAL: 'TRAVEL',
  GUARANTEE_OF_PAYMENT: 'GUARANTEE_OF_PAYMENT'
};

export const CLAIM_STATUSES = {
  PRE_VALIDATED: 'PRE_VALIDATED',
  VALIDATED: 'VALIDATED',
  DECLINED: 'DECLINED',
  PAID: 'PAID',
  DEBITED: 'DEBITED',
  PROCESSED: 'PROCESSED',
  PENDING: 'PENDING',
  INITIATED: 'INITIATED'
};

export const GUARANTEE_OF_PAYMENT_STATUSES = {
  REQUESTED: 'REQUESTED',
  ISSUED: 'ISSUED',
  DECLINED: 'DECLINED',
  PAID: 'PAID'
};

export const CLAIM_STATUS_LABELS = {
  PROCESSING: 'Processing',
  DECLINED: 'Declined',
  DONE: 'Complete',
  DRAFT: 'Draft'
};

export const getClaimProgress = (claim, statusUpdate) => {
  const { claimType, claimSubmissionStatus } = claim;

  if (claimSubmissionStatus === 'Filing') {
    return { label: CLAIM_STATUS_LABELS.DRAFT, percentage: 0, color: 'yellow' };
  }

  if (!statusUpdate || !statusUpdate.status) {
    return {
      label: CLAIM_STATUS_LABELS.PROCESSING,
      percentage: 0,
      color: 'yellow'
    };
  }

  const { status } = statusUpdate;

  if (claimType === CLAIM_TYPES.GUARANTEE_OF_PAYMENT) {
    switch (status) {
      case GUARANTEE_OF_PAYMENT_STATUSES.ISSUED:
        return { label: CLAIM_STATUS_LABELS.PROCESSING, percentage: 50, color: 'yellow' };
      case GUARANTEE_OF_PAYMENT_STATUSES.DECLINED:
        return { label: CLAIM_STATUS_LABELS.DECLINED, percentage: 50, color: 'red' };
      case GUARANTEE_OF_PAYMENT_STATUSES.PAID:
        return {
          label: CLAIM_STATUS_LABELS.DONE,
          percentage: 100,
          color: 'chateauGreen'
        };
      case GUARANTEE_OF_PAYMENT_STATUSES.REQUESTED:
      default:
        return { label: CLAIM_STATUS_LABELS.PROCESSING, percentage: 15, color: 'yellow' };
    }
  }

  switch (status) {
    case CLAIM_STATUSES.PRE_VALIDATED:
      return { label: CLAIM_STATUS_LABELS.PROCESSING, percentage: 25, color: 'yellow' };
    case CLAIM_STATUSES.VALIDATED:
      return { label: CLAIM_STATUS_LABELS.PROCESSING, percentage: 50, color: 'yellow' };
    case CLAIM_STATUSES.DECLINED:
      return { label: CLAIM_STATUS_LABELS.DECLINED, percentage: 50, color: 'red' };
    case CLAIM_STATUSES.DEBITED:
      return { label: CLAIM_STATUS_LABELS.DONE, percentage: 100, color: 'chateauGreen' };
    case CLAIM_STATUSES.PROCESSED:
    case CLAIM_STATUSES.PAID:
      return { label: CLAIM_STATUS_LABELS.DONE, percentage: 100, color: 'chateauGreen' };
    case CLAIM_STATUSES.PENDING:
    case CLAIM_STATUSES.INITIATED:
    default:
      return { label: CLAIM_STATUS_LABELS.PROCESSING, percentage: 15, color: 'yellow' };
  }
};
